




















































































import { MessageBox } from "element-ui";
import { Component, Vue } from "vue-property-decorator";
import Navbar from "../components/Navbar.vue";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    Navbar,
    RegisterLevelImages: () =>
      import("../components/Register/RegisterLevelImages.vue"),
    RegisterLevelsProgress: () =>
      import("../components/Register/RegisterLevelsProgress.vue"),
    RegisterLoginInfo: () =>
      import("../components/Register/RegisterLoginInfo.vue"),
    RegisterShop: () => import("../components/Register/RegisterShop.vue"),
    // RegisterConfirmPrivacy: () =>
    //   import("../components/Register/RegisterConfirmPrivacy.vue"),
  },
})
export default class RegisterUser extends Vue {
  levels = [
    { index: 0, name: "اطلاعات ورود" },
    { index: 1, name: "اطلاعات فروشگاه" },
  ];
  level = 0;
  referent_code: string | null = null;
  shop_address: string | null = null;
  finished = false;

  public get wormBottom(): string {
    const inverseIndex = this.levels.length - this.level;
    return `calc(${inverseIndex * 50}%)`;
  }

  nextButtonClickHandler() {
    (this.$refs["level" + this.level] as any).next();
  }

  referentCodeVerified(code: string) {
    this.referent_code = code;
    // this.level = 1;
  }

  gotToShopRegister(): void{
    this.level = 1;
  }

  allLevelsFinished(): void {
    this.finished = true;
    // this.shop_address = shop_address;
    // this.level = 3;
  }

  created(): void {
    const referral = this.$route.query.referral as string;
    const mobile = this.$route.query.mobile;
    // this.$router.replace({query: {}})
    if (referral) this.referent_code = referral;
  }

  mounted(): void {
    this.$gtag.pageview({
      page_title: this.$route.name,
      page_location: this.$route.fullPath,
      page_path: this.$route.path,
    });
  }

  beforeMount(): void {
    window.addEventListener("beforeunload", this.preventNav);
  }

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  }

  preventNav(event: Event): void {
    if (this.level === 0 || this.finished) return;
    event.preventDefault();
    event.returnValue = false;
  }

  beforeRouteLeave(to: string, from: string, next: (ok?: boolean) => void): void {
    if (this.level === 0 || this.finished) return next();

    MessageBox.confirm(
      "در این صفحه اطلاعات ذخیره نشده دارید، آیا میخواهید خارج شوید؟",
      { cancelButtonText: "لغو", confirmButtonText: "خارج میشوم" }
    )
      .then(() => {
        next();
      })
      .catch(() => {
        next(false);
      });
  }
}
